import { inject, Injectable } from '@angular/core';
import { HttpCoreService } from './http-core.service';
import { FiltersConfig, IFilterQueryResponse } from '../models/filter.models';

@Injectable()
export abstract class EntityCommunicationService<T> {
  protected httpService = inject(HttpCoreService);

  constructor(private serviceName: string) {}

  findAll(): Promise<T[]> {
    return this.httpService.get<T[]>(`api/${this.serviceName}`);
  }

  findOne(id: string): Promise<T> {
    return this.httpService.get<T>(`api/${this.serviceName}/${id}`);
  }

  createOrUpdate(entity: Partial<T>): Promise<T> {
    // if Id is present then in object, then Update all props in the object
    return this.httpService.post<T>(`api/${this.serviceName}`, entity);
  }

  query(filterConfig: FiltersConfig): Promise<IFilterQueryResponse<T>> {
    return this.httpService.post<IFilterQueryResponse<T>>(`api/${this.serviceName}/query`, filterConfig);
  }

  partialUpdate(id: string, partialUpdates: Partial<T>): Promise<T> {
    // In backend object is flattened, so Convert nested objects to dot notation eg. { "video.captions.remotion": captions.captions }
    return this.httpService.put<T>(`api/${this.serviceName}/${id}`, partialUpdates);
  }

  async remove(id: string): Promise<void> {
    await this.httpService.delete(`api/${this.serviceName}/${id}`);
  }

  clone(id: string, overrides: Partial<T> = {}): Promise<T> {
    return this.httpService.post<T>(`api/${this.serviceName}/${id}/clone`, overrides);
  }
}
